<template>
    <div class="auth_state">
        <div class="last_state mt-1">
            <span :class="get_state_class"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "auth_state",
    props: {
        cur_location: {
            type: Object,
            default: () => ({
                id: 0,
                is_ok: false,
                otp : false,

            }),
        },

        provider : {
            type : String,
            default : "glovo",
        },
    },

    data() {
        return {
            draw_state : "unknown",
        }
    },

    mounted() {
        if (parseInt(this.cur_location.id) > 0) {
            try {
                this.get_location_status();
            } catch (e) {
                console.error("ERR", e);
            }
        }
    },

    methods: {
        async get_location_status() {
            this.draw_state = 'unknown';

            try {
                const {data} = await agr_api.get('/aggregators/' + this.provider + "/" + this.cur_location.id);
                if (data.status === "operation_success") {
                    this.draw_state = 'online';
                }
            } catch (error) {
                this.draw_state = 'inactive';
                console.error("API Error:", error);
            }
        },
    },

    computed: {
        get_state_class() {
            if (this.draw_state === 'online') {
                return "status status-success";
            }

            else if (this.draw_state === 'inactive') {
                return 'status status-danger';
            }

            return 'status status-warning';
        }
    }
}
</script>

<style scoped>
.auth_state .last_state {
    position: absolute;
    top: -6px;
    left: 20px;
}
</style>
